export default __webpack_public_path__ + "static/media/18_1.ab2ecd2a.jpg";